// Author : Ayesha Shaikh
//  Date : 30 Des 2024

import {
  Backdrop,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  createTheme,
  Grid,
  Stack,
  TextField,
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import RevenueCards from "./NewRevenueCards";
import MainCard from "../../../components/Maincard";
import { useDateUtils } from "../../../utils/formatTime";
import DisplayCurrentDateTime from "../Components/DisplayCurrentDateTime";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import DetailsStats from "./DetailsStats";
import MonthlyRevenuPichart from "./MonthlyRevenuPichart";
import NewCardcomp from "../../../components/card/NewCardcomp";
import UpcommingEvents from "../Components/UpcommingEvents";

import { useGetTokenOrLogout } from "../../../utils/token";
import CentersStatAndData from "./CentersStatAndData";
import Content from "../Components/Content";
import CustomThemeDashboard from "../Components/CustomThemeDashboard";
import FilterButtonComp from "../Components/FilterButtonComp";
import CustomPopup from "../../../components/CustomPopup";

import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";
import EnrollDetails from "../popupComponent/EnrollDetails";
import MoreCardDetails from "../popupComponent/MoreCardDetails";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function CenterAdminDashboard() {
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
  const [selectedFilter, setSelectedFilter] = useState("currentmonth");

  const { currentMonthName, lastMonthName, weekRange } = useDateUtils();
  const [dailyData, setDailyData] = useState({});
  const [chosenDate, setChosenDate] = useState(new Date());
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [centerRevenueData, setCenterRevenueData] = useState([]);
  const [isCenterLoading, setIsCenterLoading] = useState(false);
  const [upcommigevent, setUpcommingEvent] = useState([]);
  const [upcommingLoading, setUpcommingLoding] = useState(false);
  const [isPieChartLoading, setIsPieChartLoading] = useState(false);
  const [pieChartData, setPieChartData] = useState({});
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState(""); 
  const [countryList, setCountryList] =useState([])
  const [countryName, setCountryName] =useState(101)

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

const handleCountryClick =(countryId)=>{
  setCountryName(countryId)
    //  handleApplyRevenuFilter(criteria, fromDate, toDate);
    //   getRevenueForCenters(criteria, fromDate, toDate);
}


    // Fetch Upcomming Event
  useEffect(() => {


 
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}country`,
     
        );
        if (response.ok) {
          const data = await response.json();
          const filteredCountry=data.filter((i)=>i.country_name==="India" || i.country_name==="Nepal" )
        setCountryList(filteredCountry)
        } else {
     console.log('server error')
     setCountryList([])
      }
    } catch (error) {
        console.log('server error')
 setCountryList([])
    }
    };

    fetchData();
  }, []);

  const handleClickFilter = (criteria, cardFilter) => {
    setSelectedFilter(criteria);

    if (criteria !== "custom") {
      handleApplyRevenuFilter(criteria, null, null);
      getRevenueForCenters(criteria, null, null);
      setFromDate(null);
      setToDate(null);
    }
    if (criteria === "custom" && fromDate !== null && toDate !== null) {
      handleApplyRevenuFilter(criteria, fromDate, toDate);
      getRevenueForCenters(criteria, fromDate, toDate);
    }
  };

  const handleDateChange = (date) => {
    setChosenDate(date);

    // getPieChartData(date)
  };

  const handleApplyRevenuFilter = async (criteria, fromDate, toDate) => {
    setRevenueLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),
 country_id : countryName,
      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route/getcenteradminrevenuebyfilter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setDailyData(result);

        setRevenueLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        setRevenueLoading(false);
        navigate("/page500");
      }
    } catch (error) {
      setRevenueLoading(false);
      navigate("/page500");
    }
  };

  const getRevenueForCenters = async (criteria, fromDate, toDate) => {
    setIsCenterLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: userId,
      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
      country_id: countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route/highestrevenuecenters`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setCenterRevenueData(result);

        setIsCenterLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        setIsCenterLoading(false);
        navigate("/page500");
      }
    } catch (error) {
      setIsCenterLoading(false);
      navigate("/page500");
    }
  };

  // Fetch Upcomming Event
  useEffect(() => {
    setUpcommingLoding(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/ongoing-upcomingevent/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          setUpcommingEvent(data);
          setUpcommingLoding(false);
        }else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
     
        navigate("/page500");
      }
    } catch (error) {
   
      navigate("/page500");
    }
    };

    fetchData();
  }, []);

  // PiechartData
  const getPieChartData = async(date) => {
    setIsPieChartLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: userId,
      date: date,
      country_id:countryName
    };

      try {
         const response = await fetch(
        `${API_ENDPOINT}route/piechart`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      if (response.ok){
        const data =await response.json()
         setPieChartData(data);
        setIsPieChartLoading(false);
      }
      else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        setIsCenterLoading(false);
        navigate("/page500");
      }
    } catch (error) {
      setIsCenterLoading(false);
      navigate("/page500");
    }

      }
  

  useEffect(() => {
    if (selectedFilter !== "custom") {
      handleApplyRevenuFilter(selectedFilter);
      getRevenueForCenters(selectedFilter);
    }
  }, [countryName]);


    useEffect(() => {
    if (selectedFilter === "custom") {
      handleApplyRevenuFilter(selectedFilter,fromDate,toDate);
      getRevenueForCenters(selectedFilter,fromDate,toDate);
    }
  }, [countryName]);

  const handleFilterDateChange = (e) => {
    setToDate(e.target.value);
  };

  useEffect(() => {
    getPieChartData(chosenDate);
  }, [chosenDate, countryName]);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };
  console.log("fromDate", fromDate);

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedFilter,
      to_date: toDate,
      from_date: fromDate,
      filter_type: cardFilter,
      country_id:countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route/getcenteradminrevenuebyfilter-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 401) {
        showSnackbar("Unknown User");
      } else if (response.status === 403) {
        showSnackbar("Unathorized User");
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };


  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Grid container spacing={2.5}>
        <Grid item xs={12} lg={9} sm={12} md={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Content />
            </Grid>

            {/* Filter Button */}
            <Grid item xs={12} sm={12} md={9} mt={2}>
              <FilterButtonComp
                selectedFilter={selectedFilter}
                handleClickFilter={handleClickFilter}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
            
              />
            </Grid>

             <Grid item xs={12} sm={12} md={3} mt={2} textAlign='end' container justifyContent='end' gap={1}>
              {countryList.map((country)=> (
             
       <Chip  
       size="small"
  label={country?.country_name}
  onClick={() => handleCountryClick(country?.id)}

  style={{
    backgroundColor: country?.id === countryName ? "#00b13f" : "transparent",
    color: country?.id === countryName ? "#fff" : "#4b4b4b",
    borderColor: country?.id === countryName ? "#00b13f" : "#ccc",
    borderWidth: 1,
    borderStyle: 'solid',
    mx: 0.5,
    fontSize:"0.7rem"
  }}
/>

         
               ))}
             </Grid>

            <Grid item xs={12} container spacing={1} gap={1}>
              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#D5F6E1"
                  title="Total Revenue"
                  iconSrc="/Group 1000002878.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.total_revenue
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Total Revenue", "total_revenue")
                  }
    countryId={countryName}

                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#E7F3FF"
                  title="Collected Revenue"
                  iconSrc="/Group 1000002854.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.total_collected_revenue
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Collected Revenue", "collected_revenue")
                  }
                   countryId={countryName}
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#FFEDFB"
                  title="Pending Revenue"
                  iconSrc="/Group 1000002879.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.total_pending_revenue
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Pending Revenue", "pending_revenue")
                  }
                   countryId={countryName}
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#FFF6E2"
                  title="STM Enrolments"
                  iconSrc="/Group 1000002880.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.total_new_enrollment
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("New Enrollments", "new_enrollments")
                  }
                />
              </Grid>
               <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#FFF6E2"
                  title="SAP Enrolments"
                  iconSrc="/Group 1000002880.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.total_sap_enrollment
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("SAP Enrolments", "sap_enrollments")
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <NewCardcomp height="425px">
                <CentersStatAndData
                  centerRevenueData={centerRevenueData}
                  isCenterLoading={isCenterLoading}
                  selectedFilter={selectedFilter}
                  fromDate={fromDate}
                  toDate={toDate}
                countryName={countryName}
                />
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} lg={3} sm={12} md={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DisplayCurrentDateTime />
            </Grid>
            <Grid item xs={12}>
              <UpcommingEvents
                data={upcommigevent}
                loading={upcommingLoading}
              />
            </Grid>

            <Grid item xs={12}>
              <NewCardcomp>
                <LeadCalandar onDateChange={handleDateChange} />
                {isPieChartLoading ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    mt={2}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <MonthlyRevenuPichart
                    loading={isPieChartLoading}
                    pieChartData={pieChartData}
                      countryName={countryName}
                  />
                )}
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          (selectedcardFilter === "new_enrollments" || selectedcardFilter === "sap_enrollments") ? (
            <EnrollDetails
              onClose={handleCloseDetailPopup}
              selectedFilter={selectedFilter}
              SelectedCardData={SelectedCardData}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : (
            <MoreCardDetails
              onClose={handleCloseDetailPopup}
              selectedFilter={selectedFilter}
              SelectedCardData={SelectedCardData}
              selectedCardName={selectedCardName}
              selectedCountFilter={selectedcardFilter}
              fromDate={fromDate}
              toDate={toDate}
              countryId={countryName}
            />
          )
        }
        title={`${selectedCardName}  Details`}
        maxWidth="lg"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
